import styled from 'styled-components';
import { mediaQueries } from "../../../utils/device";
import IsAppRouteLink from "../IsAppRouteLink";
var StyledLink = styled(IsAppRouteLink).withConfig({
  displayName: "StyledLink",
  componentId: "sc-eac612-0"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;padding:0px 2px;transition:0.1s;transform:scale(1);color:inherit;text-decoration:none;&:active{transform:scale(0.95);}@media ", "{padding:0px 8px;}"], mediaQueries.medium);
export default StyledLink;
//# sourceMappingURL=StyledLink.js.map